// extracted by mini-css-extract-plugin
export default {"avatarColumnSize":"deviceModelApplicationsRow__avatarColumnSize-JII4Z"};